import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import Vue from 'vue'

// initial state
const state = {
  bierlieferungen: [],
  loading: false,
  loaded: false,
  error: null
}

// getters
const getters = {
  bierlieferungen (state) {
    return state.bierlieferungen
  },
  bierlieferung: (state) => (id) => {
    return state.bierlieferungen.find(bierlieferung => bierlieferung.id === id)
  },
  loading (state) {
    return state.loading
  },
  error (state) {
    return state.error
  }
}

// actions
const actions = {
  loadBierlieferungen ({commit}) {
    commit('setLoading', true)
    console.log('Bierlieferungen laden...')
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('bierlieferungen').orderBy('datum', 'desc')
    .onSnapshot(snapshot => {
      const bierlieferungen = []
      snapshot.forEach(doc => {
        bierlieferungen.push({
          ...doc.data(),
          id: doc.id
        })
        commit('setLoadedBierlieferungen', bierlieferungen)
        commit('setLoading', false)
        commit('setLoaded', true)
      })
    }, (error) => {
      console.log(error)
      commit('setLoading', false)
    })
  },
  createBierlieferung ({commit, getters}, payload) {
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('bierlieferungen').add(payload)
      .catch((error) => {
        console.log(error)
      })
  // Reach out to firebase and store it
  },
  deleteBierlieferungData ({commit}, payload) {
    commit('setLoading', true)
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('bierlieferungen').doc(payload).delete()
    .then(() => {
      commit('setLoading', false)
      commit('deleteBierlieferung', payload)
    })
    .catch(error => {
      console.log(error)
      commit('setLoading', false)
    })
    commit('setLoading', false)
  },
  updateBierlieferungData ({commit}, payload) {
    commit('setLoading', true)
    const updateObj = {}
    Object.keys(payload).forEach(key => {
      if (payload[key] !== undefined) {
        updateObj[key] = payload[key]
      }
    })
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('bierlieferungen').doc(payload.id).update(updateObj)
    .then(() => {
      commit('setLoading', false)
      commit('updateBierlieferung', payload)
    })
    .catch(error => {
      console.log(error)
      commit('setLoading', false)
    })
  }
}

// mutations
const mutations = {
  setLoadedBierlieferungen (state, payload) {
    state.bierlieferungen = payload
  },
  createBierlieferung (state, payload) {
    state.bierlieferungen.push(payload)
  },
  updateBierlieferung (state, payload) {
    const bierlieferung = state.bierlieferungen.find(bierlieferung => {
      return bierlieferung.id === payload.id
    })
    Object.keys(payload).forEach(key => {
      if (payload[key]) {
        bierlieferung[key] = payload[key]
      }
    })
  },
  deleteBierlieferung (state, payload) {
    let array = state.bierlieferungen
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === payload) {
        array.splice(i, 1)
      }
    }
    state.bierlieferungen = array
  },
  setLoading (state, payload) {
    state.loading = payload
  },
  setLoaded (state, payload) {
    state.loaded = payload
  },
  setError (state, payload) {
    state.error = payload
  },
  clearError (state) {
    state.error = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/bierlieferungen_alt.js